import { EventEmitter, Injectable } from '@angular/core';
import { SearchTermChangedEvent } from "./search.service";
import { PostAndPostReaction } from "../app/app.interfaces";
import { DirectMessage } from '../app/app.interfaces';



export interface ApiLoadingInfo {
 	loading: boolean,
	method?: string,
	payload?: any
}

@Injectable()
export class EventService {

	public showNewPostDialog: EventEmitter<void> = new EventEmitter();
	public gotoNewPost: EventEmitter<void> = new EventEmitter();
	public toggleTabBar: EventEmitter<boolean> = new EventEmitter();
	public apiLoading: EventEmitter<ApiLoadingInfo> = new EventEmitter();
	public toggleMobileSidebar: EventEmitter<boolean> = new EventEmitter();
	public mobileSidebarToggled: EventEmitter<boolean> = new EventEmitter();
	public scrollToTop: EventEmitter<void> = new EventEmitter();

	public notificationDropdownItemClicked: EventEmitter<void> = new EventEmitter();
	
	public closeReactionCard: EventEmitter<boolean> = new EventEmitter();
	public closePostCreateCard: EventEmitter<boolean> = new EventEmitter();
	public closePostCard: EventEmitter<boolean> = new EventEmitter();
	public pathChanged: EventEmitter<string> = new EventEmitter();
	
	public componentActivated: EventEmitter<string|any> = new EventEmitter();
	
	public doSearch: EventEmitter<string> = new EventEmitter();
  public searchTermChanged: EventEmitter<SearchTermChangedEvent> = new EventEmitter();
  
  public appResume: EventEmitter<void> = new EventEmitter();
  
  public appLoaded: EventEmitter<void> = new EventEmitter();
  
  public reloadPosts: EventEmitter<void> = new EventEmitter();
  
  public toggleKeyboard: EventEmitter<boolean> = new EventEmitter();

	public toggleFeedbackForm: EventEmitter<boolean> = new EventEmitter();

	public setPostBestReaction: EventEmitter<PostAndPostReaction> = new EventEmitter();
	public unsetPostBestReaction: EventEmitter<PostAndPostReaction> = new EventEmitter();

	public postBestReactionSet: EventEmitter<PostAndPostReaction> = new EventEmitter();
	public postBestReactionUnset: EventEmitter<PostAndPostReaction> = new EventEmitter();


	public receivedDirectMessages: EventEmitter<DirectMessage[]> = new EventEmitter();
}



// WEBPACK FOOTER //
// ./src/services/event.service.ts